import mphelperLogo from '@/assets/mphelper-logo.png'
import mphelperMark from '@/assets/mphelper-mark.png'
import { cn } from '@/lib/utils'

interface BrandLogoProps {
  className?: string
  markClassName?: string
  textClassName?: string
  showText?: boolean
  label?: string
  variant?: 'logo' | 'mark'
}

export function BrandLogo({
  className,
  markClassName,
  textClassName,
  showText = true,
  label = 'Маркетплейс Помічник',
  variant = 'logo',
}: BrandLogoProps) {
  const imageSrc = variant === 'mark' ? mphelperMark : mphelperLogo

  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <img
        src={imageSrc}
        alt=""
        aria-hidden="true"
        className={cn('h-8 w-8 shrink-0', markClassName)}
      />
      {showText && (
        <span className={cn('min-w-0 truncate text-sm font-semibold tracking-tight', textClassName)}>
          {label}
        </span>
      )}
    </span>
  )
}
